import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { CheckIcon } from "@heroicons/react/24/outline"

import { cn } from "@/lib/utils"

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <div className="inline-flex items-center justify-center" data-slot="checkbox-wrapper">
      <CheckboxPrimitive.Root
        data-slot="checkbox"
        className={cn(
          "group outline-5 focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 aria-invalid:border-destructive shrink-0 transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 !cursor-pointer flex items-center justify-center relative",
          "min-w-10 min-h-10 w-10 h-10 p-2.5",
          className
        )}  
        {...props}
      >
        <div className={cn(
          "absolute inset-2.5 border border-line-control bg-card rounded-full shadow-xs size-5",
          "group-data-[state=checked]:bg-primary group-data-[state=checked]:border-primary",
          ""
        )} />
        <CheckboxPrimitive.Indicator
          data-slot="checkbox-indicator"
          className="flex items-center justify-center text-current transition-none !cursor-pointer absolute inset-2.5 z-10"
        >
          <CheckIcon className="size-4 text-on-primary group-data-[state=indeterminate]:text-content-secondary" />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
    </div>
  )
}

export { Checkbox }

